
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  clearFiltersIfEmpty,
  changeAddressFilterGroup,
  changeLeaseFilterGroup,
  changePropertyFilterGroup,
  changeSaleFilterGroup,
  selectAvailability,
  selectAssetClass,
  selectBuildingClass,
  selectInvestmentType,
  clearFilters,
  changeIndustrialFilterGroup,
} from '../store/actions/query';

import { delayRetrieveRecords } from '../store/actions/search';
import { filterLabelMappings, filterKeyMappings, leaseRateMappings } from 'bundles/research/index/research_constants';

import CustomFieldTags from 'bundles/comps/index/custom_fields/tags';
import CurrentFiltersGroup from 'components/research_property/current_filters_group';
import { initialState } from 'helpers/comps/database_table_constants';
import { filterByTab } from 'bundles/comps/index/custom_fields/helpers';
import { hasFilters } from 'bundles/apex/custom_fields/filters/helpers';

export class CompsCurrentFiltersGroup extends React.Component {
  static propTypes = {
    addressFilter: PropTypes.object.isRequired,
    clearFiltersIfEmpty: PropTypes.func.isRequired,
    currentTab: PropTypes.oneOf(['lease', 'sale']).isRequired,
    customFieldFilters: PropTypes.object,
    customFieldSchemas: PropTypes.array.isRequired,
    delayRetrieveRecords: PropTypes.func.isRequired,
    industrialFilter: PropTypes.object.isRequired,
    investmentTypes: PropTypes.array.isRequired,
    leaseFilter: PropTypes.object.isRequired,
    multifamilyFilter: PropTypes.object.isRequired,
    propertyFilter: PropTypes.object.isRequired,
    saleFilter: PropTypes.object.isRequired,
    selectedAssetClasses: PropTypes.array.isRequired,
    selectedAvailabilities: PropTypes.array.isRequired,
    selectedBuildingClasses: PropTypes.array.isRequired,
    selectedInvestmentTypes: PropTypes.array.isRequired,
    servedRailProviders: PropTypes.array.isRequired,
    tags: PropTypes.array,

    onAddressFilterChange: PropTypes.func.isRequired,
    onAssetClassChange: PropTypes.func.isRequired,
    onAvailabilityChange: PropTypes.func.isRequired,
    onBuildingClassChange: PropTypes.func.isRequired,
    onClearFilters: PropTypes.func.isRequired,
    onIndustrialFilterChange: PropTypes.func.isRequired,
    onInvestmentTypeChange: PropTypes.func.isRequired,
    onLeaseFilterChange: PropTypes.func.isRequired,
    onMultifamilyFilterChange: PropTypes.func.isRequired,
    onPropertyFilterChange: PropTypes.func.isRequired,
    onSaleFilterChange: PropTypes.func.isRequired
  }

  handleRetrieveRecords = () => {
    const { clearFiltersIfEmpty, delayRetrieveRecords } = this.props;
    clearFiltersIfEmpty();
    delayRetrieveRecords();
  };

  handleAddressFilterChange = (value = '', name) => {
    const { addressFilter, onAddressFilterChange } = this.props;

    addressFilter[name] = value;
    onAddressFilterChange(addressFilter);
    this.handleRetrieveRecords();
  };

  handleClearFilters = () => {
    const {
      onClearFilters,
      delayRetrieveRecords
    } = this.props;

    onClearFilters(initialState);
    delayRetrieveRecords();
  }

  handleIndustrialFilterChange = (value = '', name) => {
    const { industrialFilter, onIndustrialFilterChange } = this.props;

    industrialFilter[name] = value;
    onIndustrialFilterChange(industrialFilter);
    this.handleRetrieveRecords();
  };

  handlePropertyFilterChange = (value = '', name) => {
    const { propertyFilter, onPropertyFilterChange } = this.props;

    propertyFilter[name] = value;
    onPropertyFilterChange(propertyFilter);
    this.handleRetrieveRecords();
  };

  handleLeaseFilterChange = (value, name) => {
    const { leaseFilter, onLeaseFilterChange } = this.props;
    if (value && value.target) {
      value = value.target.value;
    }

    value = value || '';

    leaseFilter[name] = value;
    onLeaseFilterChange(leaseFilter);
    this.handleRetrieveRecords();
  };

  handleMultifamilyFilterChange = (value = '', name) => {
    const { multifamilyFilter, onMultifamilyFilterChange } = this.props;

    multifamilyFilter[name] = value;
    onMultifamilyFilterChange(multifamilyFilter);
    this.handleRetrieveRecords();
  };

  handleSaleFilterChange = (value = '', name) => {
    const { saleFilter, onSaleFilterChange } = this.props;

    saleFilter[name] = value;
    onSaleFilterChange(saleFilter);
    this.handleRetrieveRecords();
  };

  handleAvailabilityChange = (id, value) => {
    const { onAvailabilityChange } = this.props;
    onAvailabilityChange(parseInt(id), value);
    this.handleRetrieveRecords();
  };

  handleAssetClassChange = (id, value) => {
    const { onAssetClassChange } = this.props;
    onAssetClassChange(parseInt(id), value);
    this.handleRetrieveRecords();
  };

  handleBuildingClassChange = (id, value) => {
    const { onBuildingClassChange } = this.props;
    onBuildingClassChange(id, value);
    this.handleRetrieveRecords();
  };

  handleInvestmentTypeChange = (id, value) => {
    this.props.onInvestmentTypeChange(id, value);
    this.handleRetrieveRecords();
  }

  render() {
    const { currentTab, selectedBuildingClasses } = this.props;

    let customFieldTags;
    if (
      hasFilters(this.props.customFieldSchemas, this.props.customFieldFilters || {}, filterByTab(this.props.currentTab))
    ) {
      customFieldTags = <CustomFieldTags />;
    }

    return (
      <CurrentFiltersGroup
        {...this.props}
        buildingClasses={selectedBuildingClasses}
        filterKeyMappings={filterKeyMappings}
        filterLabelMappings={filterLabelMappings}
        hideLeaseFilters={currentTab != 'lease'}
        hideSaleFilters={currentTab != 'sale'}
        leaseRateMappings={leaseRateMappings}
        tags={customFieldTags}
        onAddressFilterChange={this.handleAddressFilterChange}
        onAssetClassChange={this.handleAssetClassChange}
        onAvailabilityChange={this.handleAvailabilityChange}
        onBuildingClassChange={this.handleBuildingClassChange}
        onClearFilters={this.handleClearFilters}
        onIndustrialFilterChange={this.handleIndustrialFilterChange}
        onInvestmentTypeChange={this.handleInvestmentTypeChange}
        onLeaseFilterChange={this.handleLeaseFilterChange}
        onMultifamilyFilterChange={this.handleMultifamilyFilterChange}
        onPropertyFilterChange={this.handlePropertyFilterChange}
        onSaleFilterChange={this.handleSaleFilterChange}
      />
    );
  }
}

const mapStateToProps = state => ({
  ...state.static,
  addressFilter: state.query.addressFilter,
  currentTab: state.ui.currentTab,
  customFieldFilters: state.query.customFieldFilters,
  customFieldSchemas: state.customFieldSchemas,
  industrialFilter: state.query.industrialFilter,
  investmentTypes: state.static.investmentTypes,
  leaseFilter: state.query.leaseFilter,
  multifamilyFilter: state.query.multifamilyFilter,
  propertyFilter: state.query.propertyFilter,
  saleFilter: state.query.saleFilter,
  selectedAssetClasses: state.query.assetClasses,
  selectedAvailabilities: state.query.availabilities,
  selectedBuildingClasses: state.query.buildingClasses,
  selectedInvestmentTypes: state.query.investmentTypes,
  tags: state.query.tags
});

const mapDispatchToProps = {
  clearFiltersIfEmpty,
  delayRetrieveRecords,

  onAddressFilterChange: changeAddressFilterGroup,
  onAssetClassChange: selectAssetClass,
  onAvailabilityChange: selectAvailability,
  onBuildingClassChange: selectBuildingClass,
  onClearFilters: clearFilters,
  onLeaseFilterChange: changeLeaseFilterGroup,
  onIndustrialFilterChange: changeIndustrialFilterGroup,
  onInvestmentTypeChange: selectInvestmentType,
  onSaleFilterChange: changeSaleFilterGroup,
  onPropertyFilterChange: changePropertyFilterGroup
};

export default connect(mapStateToProps, mapDispatchToProps)(CompsCurrentFiltersGroup);
